import { createCustomEnum } from "./customEnum";

const StatusCommissionSplitsTypes = createCustomEnum({
	Available: {
		value: 1,
		name: "available",
		displayName: "Available",
	},
	Unavailable: {
		value: 0,
		name: "unavailable",
		displayName: "Unavailable",
	},
});

export default StatusCommissionSplitsTypes;
